import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { GroupOrderBagButton } from '../GroupOrderBagButton/GroupOrderBagButton';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagCancelButton = (props: Props) => {
  const { isDisabled, onPress } = props;

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <GroupOrderBagButton icon="IconUnavailable" isDisabled={isDisabled} onPress={onPress}>
      <FormattedMessage {...messages.label} />
    </GroupOrderBagButton>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  label: {
    defaultMessage: 'Cancel group order',
    description: 'Bag | Group order | Cancel group order CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  onPress: () => void;
};
